import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CompanyService } from '../../../services/company.service';
import { Company } from '../../../common/models/company/company';
import { CompanyType } from '../../../common/models/company/company-type.enum';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'psc-company-profile',
  templateUrl: './company-profile.component.html',
})
export class CompanyProfileComponent implements OnInit {
  formGroup: FormGroup;
  loading: boolean = false;
  company: Company;
  userIsExpired: boolean;


  constructor(
    private companyService: CompanyService,
    private authService: AuthService,
  ) {
  }

  ngOnInit(): void {
    this.userIsExpired = this.authService.userHasExpiredRole();
    this.loading = true;
    this.companyService.getMyCompany().subscribe((company) => {
      this.company = company;
      this.loading = false;
    });
  }

  protected readonly CompanyType = CompanyType;

  companyChanged(company: Company) {
    this.company = company;
  }
}
